// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATIONS_EN = {
  // Vacancy actions
  RequiredPermissions: 'Required permissions granted',
  PermissionsRevoked: 'Permissions revoked',
  FileSaved: 'File saved',
  ErrorOccurred: 'An error occurred, reload the page',
  NoApplicantsYet: 'There are no applicants to show yet',
  Found: 'We found ',
  Applicants: 'applicants',
  NoEmptyName: 'A column cannot have an empty name',
  TryLater: 'An error ocurred, try again later',
  ApplicantSaved: 'Candidate saved',
  NoSavedAnymore: 'Candidate deleted from the saved list',
  CandidateTransferred: 'Candidate has been transferred',
  AlreadyTransferred: 'Candidate already transferred',
  InvitationSent: 'Invitation email sent',
  ImpossibleToDelete: 'It is not possible to delete the candidate',
  VacancyUpdated: 'Vacancy updated',
  NoSameColumn: 'Cannot select the same column',
  AtLeastOne: 'Have to select at least one candidate',

  // Company actions
  DataInvoice: 'Some info is missing for invoicing',
  CannotIntegrate: 'It was not possible the integration',
  TokenError: 'Token error',
  SatisfactionSurvey: 'Satisfaction survey saved',
  IndustryUpdated: 'Industry updated',
  ImageAdded: 'Image added',
  ErrorWhileSaving: 'An error has occurred while saving your info, please try again',
  EmailFormat: 'Email formats saved',
  EmailSent: 'Email sent',
  LimitSaved: 'Limit saved',
  EmptyField: 'Empty field',
  EmailSaved: 'Email saved',
  SpontaneousActivated: 'Spontaneous vacancy activated',
  SpontaneousDeactivated: 'Spontaneous vacancy deactivated',
  CardSaved: 'Card saved',
  NewCard: 'New card',
  DeclinedCard: 'Card rejected',
  UpdatedCard: 'Card updated',
  DeletedCard: 'Card deleted',
  DeptoUpdated: 'Department updated',
  DeptoAdded: 'Department added',
  CompanyValues: 'It was not possible to save Company values',
  DesirableValues: 'Desirable values saved',
  CouldNotSaveDesirableValues: 'It was not possible to save Desirable values',
  SubdomainRegistered: 'Subdomain registered',
  ErrorUpdatingSubdomain: 'An error occurred while updating the subdomain',
  TemplateDeleted: 'Template deleted',

  // Survey index
  RangeWarning: 'Ranges only allow values from 0 to 10',
  MinimumOptions: 'Closed questions require at least 2 options',
  QuestionWarning: 'Empty or already existing',
  SelectWarning: 'A question type must be selected',

  // Spli form:
  FillAll: 'Fill all fields',

  // Job actions
  SuccessfullySaved: 'Your vacancy was successfully saved!',
  ErrorUpdatingVacancy: 'An error occurred while updating the vacancy',
  VacancyPublished: 'Vacancy published',
  PaymentDone: 'Your payment was successfully done!',

  // User actions
  ErrorSendingEmail: 'An error occurred while sending the email, please try again later',
  OutlookLinked: 'Outlook linked',
  SlackLinked: 'Slack linked',
  TeamsLinked: 'Teams linked',
  ErrorCode: 'There is an error in the verification code, please try again',
  PermissionsUpdated: 'Permissions updates',
  ErrorUpdatingPermissions: 'An error occurred while updating permissions',
  PermissionsObtained: 'Permissions obtained',
  EventSaved: 'Event saved',
  EventAlreadySaved: 'You already have a programmed event',
  UserUpdated: 'User updated',
  UserRegistered: 'User registered',
  ImgUpdated: 'Image updated',
  UserDeleted: 'User deleted',
  CouldNotUpdate: 'The update failed, please try again',
  EmailAlreadyUsed: 'This email was already registered',

  // loadCriterial
  CriterionUpdated: 'Criterion updated',
  CriterionSaved: 'Criterion saved',
  CriterionDeleted: 'Criterion deleted',
  TryAgainLater: 'Try again later',
};
